<template>
  <bar-chart :chartdata="chartdata" :styles="styles"/>
</template>

<script>
import BarChart from '@/components/charts/bar'

export default {
  name: 'AlertPriorityCount',
  components: {
    BarChart
  },
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    critical: {
      type: Array,
      default: () => []
    },
    downgraded: {
      type: Array,
      default: () => []
    },
    warning: {
      type: Array,
      default: () => []
    },
    task: {
      type: Array,
      default: () => []
    },
    informational: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      chartdata: null,
      styles: {
        height: '34.75vh',
        width: '100%',
        position: 'relative'
      }
    }
  },
  methods: {
    fillchartdata: function () {
      this.chartdata = {
        labels: this.labels,
        datasets: [
          {
            label: 'critical',
            backgroundColor: 'rgba(180, 35, 35, 0.7)',
            borderColor: 'rgba(180, 35, 35, 1)',
            borderWidth: 1,
            data: this.critical
          },
          {
            label: 'downgraded',
            backgroundColor: 'rgba(240, 161, 112, 0.7)',
            borderColor: 'rgba(240, 161, 112, 1)',
            borderWidth: 1,
            data: this.downgraded
          },
          {
            label: 'warning',
            backgroundColor: 'rgba(255, 214, 51, 0.7)',
            borderColor: 'rgba(255, 214, 51, 1)',
            borderWidth: 1,
            data: this.warning
          },
          {
            label: 'task',
            backgroundColor: 'rgba(0, 153, 204, 0.7)',
            borderColor: 'rgba(0, 153, 204, 1)',
            borderWidth: 1,
            data: this.task
          },
          {
            label: 'info',
            backgroundColor: 'rgba(56, 118, 29, 0.7)',
            borderColor: 'rgba(56, 118, 29, 1)',
            borderWidth: 1,
            data: this.informational
          }
        ]
      }
    }
  },
  created: function () {
    this.fillchartdata()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/AlertPriorityCount.vue